import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDenied implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}